import styled, { keyframes } from "styled-components";

import * as Types from "Types";

import { arrowDown } from "icons";

const ani = keyframes`
  0% {
    transform: translateY(0%);
  }
  100% {
   transform: translateY(10%);
  }
`;

const Wrap = styled.a<Types.Default>`
   display: flex;
   flex-direction: column;
   row-gap: 15px;
   align-items: center;
   cursor: pointer;
   ${({ css }) => css}
`;

const Icon = styled.img<any>`
   width: 41px;
   animation-iteration-count: infinite;
   animation-direction: alternate;
   animation-duration: 1s;
   animation-timing-function: linear;
   animation-name: ${ani};
`;

const Text = styled.div`
   font-size: 24px;
   font-weight: 900;
`;

export default function More(props: Types.Atoms.More) {
   return (
      <Wrap {...props}>
         <Text>MORE</Text>
         <Icon src={arrowDown} alt="" />
      </Wrap>
   );
}
